<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expertkltp">Экспертиза промышленной безопасности
    </div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expprombez/">Проведение экспертизы промышленной безопасности (ЭПБ)</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expprombez/teplpset">Теплосеть ОПО: экспертиза промышленной безопасности, ввод в эксплуатацию теплосети, акт допуска

    </div>
  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Теплосеть ОПО: экспертиза промышленной безопасности, ввод в эксплуатацию теплосети, акт допуска


    </h1>
    <ul class="link-arrow">
      <li>- Полный комплекс услуг: от ЭПБ до лицензирования</li>
      <li>- В полном соответствии с действующим законодательством</li>
      <li>- Комплексный подход</li>
      <li>- Работаем с 2003 года</li>
    </ul>
    <app-recall-form heading="Требуется акт допуска тепловых сетей или регистрация теплосети? Получите консультацию эксперта."></app-recall-form>
    <h2>Регистрация теплосети:</h2>

    <p>Для эксплуатации теплосетей на законных основаниях необходимо:</p>

    <ul class="marked ml-50">
      <li>провести экспертизу промышленной безопасности тепловых сетей с последующей паспортизацией, техническое освидетельствование;</li>
      <li>оформить акт ввода тепловой сети;</li>
      <li>осуществить ввод в эксплуатацию теплосети, как оборудования, работающего под избыточным давлением (&laquo;котлонадзор&raquo;);</li>
      <li>постановить теплосеть на учет;</li>
      <li>идентифицировать и присвоить класс опасности участку трубопровода теплосети;</li>
      <li>осуществить регистрацию теплосети (в т.ч. ОПО ИТП) в государственном реестре Ростехнадзора;</li>
      <li>
        <p>предоставить нормативную, проектную и испольнительную документацию тепловых сетей (регистрация ОПО осушествляется в Ростехнадзоре);</p>
      </li>
      <li>сформировать комплект документов на оформление лицензии.</li>
    </ul>

    <div>
      <p><strong>Мы с 2003 года оказываем услуги в области промышленной безопасности и гарантируем проведение экспертизы промышленной безопасности тепловой сети, эпб трубопровода теплосети на основании лицензии и в полном соответствии с действующим законодательством. </strong></p>

      <p><strong>Вам необходима регистрация теплосети или помощь в оформлении документов? Специалисты ООО &laquo;Протос Экспертиза&raquo; дадут необходимые разъяснения по каждому из этапов и помогут зарегистрировать объект тепловых сетей ОПО. Вы можете связаться с нами любым удобным для Вас способом или оставить контакты для связи с Вами.</strong></p>
    </div>
    <app-recall-form heading="У Вас есть вопрос или требуется акт ввода в эксплуатацию теплосети? Наши специалисты с Вами свяжутся"></app-recall-form>
    <div class="blue-block">
      <p><em>Справочная информация:</em>&nbsp;в конце 2023 года изменились требования к оформлению акта ввода в эксплуатацию теплосетей, трубопроводов, тепловых пунктов, подлежащих учету в Ростехнадзоре. Так, при вводе в эксплуатацию &ndash;указывается рабочее давление, соответствующее давлению подающего магистрального трубопровода (независимо от параметров, указанных в проектной документации, разрешении на присоединение и т.д.).</p>

      <p>В случае, если рабочее давление составляет 1,6 МПа в подающем трубопроводе, то ОПО будет присвоен III класса опасности и потребуется оформление лицензии на эксплуатацию теплосети.</p>

    </div>
    <p>Для проведения <strong>экспертизы промышленной безопасности</strong> теплосетей <strong>заказчику потребуется</strong> предоставить:</p>

    <ol class="marked" style="margin-left: 14px;">
      <li>Доступ к трубопроводам и устройствам, включая их подготовку к проведению экспертизы;</li>
      <li>Копии:</li>
    </ol>

    <ul class="marked" style="margin-left: 70px;">
      <li>проектной документации в полном объеме на все участки трубопроводов и тепловых сетей (с соответствующей экспертизой);</li>
      <li>исполнительной документации на первоначальное строительство трубопроводов наружного участка теплосети н в ИТП;</li>
    </ul>

    <div class="mt-4">
      <p><strong>Не допускается проведение ЭПБ в отношении собственных ОПО. </strong>Ответственность за несоблюдение лежит на руководителе эксплуатирующей организации.</p>
    </div>

    <p>По результатам эпб трубопроводов и тепловых сетей разрабатывается паспорт, содержащий сведения о проведенной экспертизе и техническом освидетельствовании, выдается заключение экспертизы промышленной безопасности, которое требуется зарегистрировать в государственном реестре Ростехнадзора.</p>

    <p><strong>Если вам необходимо провести эпб трубопровода теплосети в Москве или других регионах, оформить акт-допуск на эксплуатацию тепловых сетей, определить класс опасности или устранить замечания МОЭК или энергоснабжающей организации &ndash; наши специалисты проконсультируют и помогут на любом этапе. Мы оказываем услуги в области промышленной безопасности с 2003 года. </strong></p>

    <app-atomka-calc class="w-100" heading="Получить консультацию по проведению ЭПБ, цене и условиям"></app-atomka-calc>
    <app-recall-form heading="У вас есть вопрос? Мы вам перезвоним!"></app-recall-form>
    <app-reviews-block class="w-100"></app-reviews-block>
  </div>
</div>
<app-footer></app-footer>
